// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2UtNc","comment":"styles_comment__2fUV_"};